export default {
  createTask: 'Create Task',
  createPianoTask: 'Create Piano Task',
  createWorkTask: 'Create Work Task',
  createSmtOrder: 'Add SMT Order',
  colName: 'Task Name',
  colDeviceName: 'Device Name',
  colSn: 'Device SN',
  colType: 'Type',
  colStatus: 'Status',
  colRunTime: 'Run Time',
  colCreateTime: 'Create Time',
  colAction: 'Actions',
  statusDone: 'Completed',
  statusInProgress: 'In Progress',
  statusNotStarted: 'Not Started',
  typePiano: 'Piano',
  typeDance: 'Dance',
  typeSingDance: 'Sing & Dance',
  typeWork: 'Work',

  labelTaskName: 'Task Name',
  labelWorkRobot: 'Work Robot',
  labelWorkDescription: 'Work Description',
  placeholderWorkRobot: 'Select work robot',
  placeholderWorkDescription: 'Enter work description',
  ruleWorkRobot: 'Please select a work robot',
  ruleWorkDescription: 'Please enter a work description',
  ruleWorkDescriptionLength: 'Length must be 1–200 characters',
  placeholderTaskName: 'Enter task name',
  labelSong: 'Song',
  placeholderSongRobot: 'Select piano robot',
  placeholderSong: 'Select song',
  labelDance: 'Dance',
  placeholderDanceRobot: 'Select dance robot',
  placeholderDance: 'Select dance',
  labelTaskStrategy: 'Strategy',
  strategyImmediate: 'Run Now',
  strategyTimed: 'Not Now',
  strategyDaily: 'Scheduled',
  labelSchedulePlan: 'Schedule',
  placeholderScheduleTime: 'Select execution time',
  cancel: 'Cancel',
  confirm: 'Confirm',
  danceBaseTest: 'Basic Test',

  ruleTaskNameRequired: 'Please enter a task name',
  ruleTaskNameLength: 'Length must be 1–20 characters',
  rulePianoRobot: 'Please select a piano robot',
  ruleDanceRobot: 'Please select a dance robot',
  ruleTaskType: 'Please select a task strategy',

  errSongOrDance: 'Select at least a song or a dance',
  errDailyNeedsSong: 'Scheduled tasks require a song',
  errScheduleFields: 'Select an execution time',
  successCreate: 'Task created successfully',
  failCreate: 'Failed to create task',

  labelPickup: 'Unload Point',
  labelDelivery: 'Load Point',
  labelTotalTrays: 'Tray Count',
  labelPickupAreaCodes: 'Area Code',
  placeholderPickup: 'Enter unload waypoint, e.g. LM1',
  placeholderDelivery: 'Enter load waypoint, e.g. LM3',
  placeholderTotalTrays: 'Enter total trays to pick for this order',
  placeholderPickupAreaCodes: 'Enter area codes, comma-separated, e.g. 4L,5L',
  rulePickup: 'Please enter unload point',
  ruleDelivery: 'Please enter load point',
  ruleTotalTrays: 'Please enter tray count',
  rulePickupAreaCodes: 'Please enter area code',
  successCreateSmtOrder: 'SMT order created successfully',
  failCreateSmtOrder: 'Failed to create SMT order',

  deleteButton: 'Delete',
  deleteConfirmTitle: 'Are you sure you want to delete this task?',
  deleteSuccess: 'Task deleted successfully',
  deleteFail: 'Failed to delete task',
  deleteConfirm: {
    title: 'Delete task "{name}"?',
    content: 'This action cannot be undone.',
    okText: 'Delete',
    cancelText: 'Cancel',
  },
}
